import { useState } from 'react';
import Table from '../Listing/Table';
import Modal from '../Modal/Modal';
import { Document, Page, pdfjs } from 'react-pdf';
import usePaymentColumns from '../../hooks/paymentColumns';

import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const OrderPayments = ({ payments }) => {
    const [pdfData, setPdfData] = useState(null);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    // Same shared column set as the main /payments listing (badges, patient avatar,
    // amount styling, actions menu) — patientId is dropped since every row here
    // already belongs to this order's one patient.
    const columns = usePaymentColumns({
        setPdfData,
        setShowPdfModal,
        setPageNumber,
        excludeColumns: ['patientId'],
    });

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <>
            <Table mode="client" data={payments} columns={columns} emptyMessage="Aucun paiement" multiSelect={true} />

            <Modal title="Visualisation du reçu PDF" show={showPdfModal} onClose={() => setShowPdfModal(false)} classSize="modal-lg">
                {pdfData ? (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Document
                                file={pdfData}
                                onLoadSuccess={onDocumentLoadSuccess}
                            >
                                <Page pageNumber={pageNumber} width={680} />
                            </Document>
                        </div>

                        {numPages > 1 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    disabled={pageNumber <= 1}
                                    onClick={() => setPageNumber(pageNumber - 1)}
                                >
                                    Précédent
                                </button>
                                <span className="text-muted small">Page {pageNumber} / {numPages}</span>
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    disabled={pageNumber >= numPages}
                                    onClick={() => setPageNumber(pageNumber + 1)}
                                >
                                    Suivant
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="text-center py-4 text-muted">Chargement du PDF...</div>
                )}
            </Modal>
        </>
    );
};

export default OrderPayments;
